import { RequirementType } from "@wingspanhq/payments/dist/interfaces";
import { RequirementExpirationStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";
import * as Yup from "yup";

const allowedTypes = Object.values(RequirementType);
const defaultExpirationStrategies = Object.values(
  RequirementExpirationStrategy
);

const allAllowedExpirationStrategiesValues = [
  ...defaultExpirationStrategies,
  "None"
];

type SettingsFieldsConfig = {
  noExpirationForm: boolean;
};

export const settingsFieldsValidationSchema = (config: SettingsFieldsConfig) =>
  Yup.object().shape({
    expirationDays: config.noExpirationForm
      ? Yup.mixed().notRequired()
      : Yup.mixed().when("expirationStrategy", {
          is(type: RequirementExpirationStrategy) {
            return [
              RequirementExpirationStrategy.DaysBeforeYearEnd,
              RequirementExpirationStrategy.DaysAfterComplete,
              RequirementExpirationStrategy.DaysAfterYearStart
            ].includes(type);
          },
          otherwise: Yup.string().notRequired(),
          then: Yup.number()
            .min(1)
            .max(10 * 365)
            .required("Expiration days is required")
        }),
    expirationStrategy: config.noExpirationForm
      ? Yup.mixed().notRequired()
      : Yup.string().oneOf(allAllowedExpirationStrategiesValues),
    manualRenewalAllowed: Yup.boolean().notRequired()
  });

export const requirementDefinitionDefaultValidationSchema = (config: {
  noExpirationForm: boolean;
}) =>
  Yup.object()
    .shape({
      description: Yup.string(),
      instructions: Yup.mixed().when("type", {
        is(type: RequirementType) {
          return [
            RequirementType.BackgroundCheck,
            RequirementType.SharedFile,
            RequirementType.IdentityVerification
          ].includes(type);
        },
        otherwise: Yup.mixed().notRequired(),
        then: Yup.string()
      }),
      name: Yup.string().required("Name is required"),
      type: Yup.string().oneOf(allowedTypes).required("Type is required")
    })
    .concat(settingsFieldsValidationSchema(config));
